/**
 * 节点管理
 */
import { pluginManager } from "./index";
import { defaultSchemaList } from "../components/OrginRecordWord/config/formItemsConfig";
const originalRecord = [
  {
    title: '页面布局',
    textList: [
      {
        text: '页面布局：可拖拽到列表里，生成表格模板',
      }
    ],
    id: '3',
    list: [
      "模板一",
    ]
  },
  {
    title: '检测信息',
    textList: [
      {
        text: '检测信息：可拖拽到列表里，检测结果录入时系统自动带出信息，不需要录入；',
      },
      {
        text: '提示：原始记录表配置不用特意对齐表格，系统会根据内容自动对齐，只要预览结果符合要求就可以了。'
      }
    ],
    id: '0',
    list: [
      "检测项目",
      "检测依据",
      "检测标准",
      "检验环境",
      "检测仪器",
      "培养基配制",
      "送检日期",
      "检验日期",
      // "计算公式",
      "验样"
    ]
  },
  {
    title: '签名配置',
    id: '1',
    textList: [
      {
        text: '签名配置：可拖拽到列表里，检测结果录入时系统自动带出信息，不需要录入；',
      },
      {
        text: '提示：原始记录表配置不用特意对齐表格，系统会根据内容自动对齐，只要预览结果符合要求就可以了。'
      }
    ],
    list: [
      "检验者",
      '检测日期',
      "校核者",
      '校核日期'
    ]
  },
  {
    title: '自定义配置',
    textList: [
      { text: ' （1）输入框：在表格里插入输入框可以在原始记录里输入内容也可以在检测结果录入时输入；' },
      { text: ' （2）固定文字：可以在表格里输入固定文字例如样品制备或其他固定内容，检测结果会带出信息不需要录入；' },
      { text: '（3）检测结果：检测结果配置是需要在检测结果录入输入结果。' },
      { text: '提示：原始记录表配置不用特意对齐表格，系统会根据内容自动对齐，只要预览结果符合要求就可以了。' }
    ],
    id: '2',
    list: [
      "输入框",
      "固定文字",
      "检测结果"
      // "多选项",
      // "数据字典",
    ]
  },
]
const title=localStorage.getItem('title');
console.log(title,'titletitletitletitle');
class NodeSchema {
  schemaList = [];
  schemaGroup = originalRecord
  designSchemaGroup = [];

  /**
   * 添加节点结构数据
   * @param {*} schemas []
   * @returns
   */
  addSchemas(schemas) {
    const s = schemas.map(item => {
      // 存在component组件则添加到插件管理器中
      item.component && pluginManager.addComponent(item.label, item.component);
      // 删除schemas中的component属性
      delete item.component;
      return item;
    });

    return this.schemaList.push(...s);
  }

  /**
   * 获取所有node schema
   * @returns
   */
  getSchemaList() {
    return this.schemaList;
  }

  /**
   * 通过type查询node schema
   * @returns
   */
  getSchemaByType(label) {
    console.log(label, 'typetype11111111111');
    const schemaList = this.schemaList;
    for (const i in schemaList) {
      if (schemaList[i].label === label) {
        console.log(type, 'type2222222222222');
        return schemaList[i];
      }
    }
    return null;
  }

  /**
   * 设置分组,这个操作将会覆盖原来的数据
   * @param {*} schemaGroup
   * @returns
   */
  setSchemaGroup(schemaGroup) {
    this.schemaGroup = schemaGroup;
  }

  /**
   * 添加分组
   * @param {*} schemaGroupItem
   * @returns
   */
  addSchemaGroup(schemaGroupItem) {
    this.schemaGroup.push(schemaGroupItem);
    this.designSchemaGroup.length = 0;
    this.designSchemaGroup.push(...this.getSchemaByGroup());
  }

  /**
   * 添加计算schemaGroup 值
   * @param {*} schemaGroup
   */
  addComputed(schemaGroup) {
    this.designSchemaGroup = schemaGroup;
    schemaGroup.push(...this.getSchemaByGroup());
  }

  /**
   * 按照分组获取schemaGroupList
   * @returns schemaGroupList
   */
  getSchemaByGroup() {
    const schemaGroupList = this.schemaGroup.map(item => {
      const list = this.schemaList.filter(v => {
        return item.list.includes(v.label);
      });
      return {
        ...item,
        list
      };
    });
    // console.log(schemaGroupList, 'schemaGroupList');
    return schemaGroupList;
  }
}

export const nodeSchema = new NodeSchema();
nodeSchema.addSchemas(defaultSchemaList);
